// 封装axios


import axios from 'axios'
// import local from "@/tools/local"
//使用单独引入的方法来使用弹窗
import { Message } from 'element-ui';
// import { locale } from 'core-js';
// import router from "@/router"
import myUtil from "@/tools/myUtil.js";
import Qs from "qs"

const axios_timeout = 60 * 1000 //请求超时限制

const service = axios.create({
    /**
     * 2023-2-16 做修改地址的前缀统一到myUtil中做修改
     */
    baseURL: myUtil.baseURL(),
    timeout: axios_timeout
})



// 2.请求拦截器
service.interceptors.request.use(config => {
    //发请求前做的一些处理，数据转化，配置请求头，设置token,设置loading等，根据需求去添加
    //  console.log(config.url);
    // console.log(config);
    //2022-9-27 添加内部产品资格判断
    if (config.url && config.url.indexOf("warehouse-in-item") != -1 && config.params) {
        config.params.userLevel = "内部测试";
    }

    if (config.params && config.params.serverType == 1) {
        config.baseURL = myUtil.serveBaseUrl();
    } else if (config.params && config.params.serverType == 2) {
        config.baseURL = myUtil.serveBaseUrl_old();
    } else if (config.params && config.params.serverType == 3) {
        config.baseURL = myUtil.serveBaseUrl_wang();
    }

    if (config.data) {
        let QsData = Qs.parse(config.data);
        if (QsData.serverType && QsData.serverType == 1) {
            config.baseURL = myUtil.serveBaseUrl();
        }
    }

    return config
})

service.interceptors.response.use((response) => {
        // console.log(response);

        if (response.data.success == true || response.status == 200) {
			console.log(1);
        } else {
            if (response.config.url == "/hjrkj/customer/getList") {
				console.log(1);
            }
            switch (response.config.url) {
                case "/hjrkj/customer/getList":

                    break;

                default:

                    Message.error(response.data.errMsg);
                    break;
            }
        }

        return response
    },
    err => {
        if (err.config) {
            if (err.config.timeout <= axios_timeout) {
                const stutas_code = err.message.substring(err.message.length - 3, err.message.length)
                switch (Number(stutas_code)) {
                    case 400:
                        Message.error('错误请求')
                        break;
                    case 401:
                        Message.error('未授权，请重新登录')
                        break;
                    case 403:
                        Message.error('拒绝访问')
                        break;
                    case 404:
                        Message.error('请求错误,未找到该资源')
                        break;
                    case 405:
                        Message.error('请求方法未允许')
                        break;
                    case 408:
                        Message.error('请求超时')
                        break;
                    case 500:
                        Message.error('服务器端出错')
                        break;
                    case 501:
                        Message.error('网络未实现')
                        break;
                    case 502:
                        Message.error('网络错误')
                        break;
                    case 503:
                        Message.error('服务不可用')
                        break;
                    case 504:
                        Message.error('网络超时')
                        break;
                    case 505:
                        Message.error('http版本不支持该请求')
                        break;
                    default:
                        Message.error('其他未知错误')
                }
            } else {
                Message.error('请求超时')
            }
        } else {
            Message.error('请检查网络')
        }



    })



export default service;